<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">
        지면 옵션 등록
        <span class="attention-coment-1">
          <v-icon>mdi-alert-circle</v-icon>
          옵션 등록 후 지면에 추가하여 셋업할 수 있습니다!
        </span>
      </h2>

      <v-form ref="form">
        <!-- 옵션명, 옵션키 -->
        <div class="form-wrap">
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              옵션명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <v-text-field
                class="input-custom-2"
                height="40px"
                v-model="optionGroup.name"
                :rules="[rules.required, rules.maxLength(20)]"
                placeholder="20자 이내 입력해주세요"
                solo
                required
              ></v-text-field>
            </div>
          </div>

          <div class="form-group mb-8">
            <h3 class="title-type-3">
              옵션키
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <v-text-field
                class="input-custom-2"
                height="40px"
                v-model="optionGroup.key"
                :rules="[rules.required, rules.maxLength(20)]"
                placeholder="20자 이내 입력해주세요"
                solo
                required
              ></v-text-field>
            </div>
          </div>
        </div>
        <!-- //옵션명, 옵션키 -->

        <!-- 매체 타입, 옵션 타입 -->
        <div class="form-wrap">
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              매체 타입
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <v-select
                :items="mediaTypeItems"
                label="선택"
                item-text="label"
                item-value="value"
                v-model="optionGroup.media_type"
                :rules="[rules.required]"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                :disabled="$route.name === 'mediaOptionModify'"
                solo
                required
              ></v-select>
            </div>
          </div>

          <div class="form-group mb-8">
            <h3 class="title-type-3">
              옵션 타입
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6">
              <v-select
                :items="optionGroupTypes"
                label="선택"
                v-model="optionGroup.type"
                :rules="[rules.required]"
                item-color="#000"
                class="input-custom-2"
                height="40px"
                solo
                required
              ></v-select>
            </div>
          </div>
        </div>
        <!-- //매체 타입, 옵션 타입 -->

        <!-- 옵션 설명 -->
        <h3 class="title-type-3">
          옵션 설명
          <span class="required">
            <v-icon>mdi-check-circle-outline</v-icon>
            필수
          </span>
        </h3>
        <div class="relative white rounded pa-6 mb-8">
          <v-text-field
            class="input-custom-2"
            height="40px"
            v-model="optionGroup.note"
            :rules="[rules.required, rules.maxLength(50)]"
            placeholder="50자 이내 입력해주세요"
            solo
            required
          ></v-text-field>
        </div>
        <!-- //옵션 설명 -->

        <div class="mb-8">
          <h4 class="title-type-3 d-flex justify-space-between">
            <div>옵션 아이템</div>

            <div>
              <v-btn
                large
                depressed
                max-height="32px"
                color="#fecd06"
                class="button-type-1"
                @click="appendOptionItem"
              >
                <v-icon left> mdi-plus </v-icon>
                아이템 추가
              </v-btn>
            </div>
          </h4>

          <template>
            <div
              class="relative white rounded pa-6 pr-16"
              v-for="(optionItem, i) in optionGroup.items"
              :key="i"
              :class="{ [`mt-4`]: i !== 0 }"
            >
              <div class="holev-gap">
                <div
                  class="resource-cont relative white rounded pa-6 pb-8 pr-16"
                >
                  <div class="resource-box relative">
                    <!-- 아이템명 -->
                    <div class="form-row-1">
                      <p class="label">
                        아이템명
                        <span class="required">
                          <v-icon>mdi-check-circle-outline</v-icon>
                          필수
                        </span>
                      </p>
                      <div class="write-con">
                        <div class="">
                          <v-text-field
                            v-model="optionItem.name"
                            label="아이템명을 입력해주세요."
                            class="input-custom-2"
                            height="40px"
                            solo
                            :rules="[rules.required, rules.maxLength(20)]"
                          ></v-text-field>
                        </div>
                      </div>
                    </div>
                    <!-- //아이템명 -->
                    <!-- 클라이언트 키 -->
                    <div class="form-row-1">
                      <p class="label">
                        클라이언트 키
                        <span class="required">
                          <v-icon>mdi-check-circle-outline</v-icon>
                          필수
                        </span>
                      </p>
                      <div class="write-con">
                        <v-text-field
                          v-model="optionItem.client_key"
                          label="클라이언트 키를 입력해주세요."
                          class="input-custom-2"
                          height="40px"
                          solo
                          :rules="[rules.required, rules.maxLength(20)]"
                        ></v-text-field>
                      </div>
                    </div>
                    <!-- //클라이언트 키 -->
                    <!-- 노출여부 -->
                    <div class="form-row-1">
                      <p class="label">
                        노출관리
                        <span class="required">
                          <v-icon>mdi-check-circle-outline</v-icon>
                          필수
                        </span>
                      </p>
                      <div class="write-con">
                        <v-radio-group
                          v-model="optionItem.is_valid"
                          class="mt-0"
                          row
                          :rules="[rules.required]"
                        >
                          <v-radio
                            label="ON"
                            value="Y"
                            color="#fecd00"
                            class="radio-type-1"
                          ></v-radio>
                          <v-radio
                            label="OFF"
                            value="N"
                            color="#fecd00"
                            class="radio-type-1 ml-10"
                          ></v-radio>
                        </v-radio-group>
                      </div>
                    </div>
                    <!-- //노출여부 -->
                    <!-- 아이템삭제버튼 -->
                    <a
                      class="btn-ico-delete"
                      @click="openRemoveConfirmPopup(optionItem, i)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </a>
                    <!--// 아이템삭제버튼 -->
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="d-flex justify-end mt-10">
          <v-btn
            large
            depressed
            min-width="104px"
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.stop="$router.push({ name: 'mediaOption' })"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            min-width="104px"
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-4"
            @click="registerOption"
          >
            저장
          </v-btn>
        </div>
      </v-form>
    </div>

    <SystemAlert v-model="systemAlert.show">
      <div slot="noti-text">{{ systemAlert.message }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="systemAlert.continue"
        >
          확인
        </v-btn>
        <v-btn
          v-if="systemAlert.abort"
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1 ml-2"
          @click.stop="systemAlert.abort"
        >
          취소
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import {
  detailOptions,
  createOptionGroup,
  updateOptionGroup,
  deleteOptionItem,
} from '@/api/options';
import { constantMediaType2 as constantMediaType } from '@/utils/constant';
import SystemAlert from '~@/modal/SystemAlert.vue';

export default {
  components: { SystemAlert },
  data: () => ({
    optionGroup: {
      name: null,
      key: null,
      media_type: null,
      type: null,
      note: null,
      items: [],
    },
    mediaTypeItems: Object.keys({ all: 'ALL', ...constantMediaType }).map(
      k => ({
        value: k,
        label: constantMediaType[k] ? constantMediaType[k] : 'ALL',
      }),
    ),
    optionGroupTypes: ['bool', 'checkbox', 'number'],
    rules: {
      required: v => !!v || '필수 항목입니다.',
      maxLength: length => {
        return v =>
          (!!v && v.length <= length) || `최대 ${length}자까지 가능합니다.`;
      },
      isNumber: v => (!!v && /^[0-9]+$/.test(v)) || '숫자만 가능합니다.',
      isKrEn: v =>
        (!!v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글/영문만 입력 가능합니다.',
    },
    systemAlert: {
      show: false,
      message: null,
      continue: null,
      abort: null,
      reloadLineitem: null,
    },
  }),
  methods: {
    defaultOptionGroup() {
      return {
        name: null,
        key: null,
        media_type: null,
        type: null,
        note: null,
        items: [this.defaultOptionItem()],
      };
    },
    defaultOptionItem() {
      return { name: null, client_key: null, is_valid: null };
    },
    appendOptionItem() {
      this.optionGroup.items.push(this.defaultOptionItem());
    },
    async getOption(optionGroupId) {
      try {
        if (!optionGroupId) {
          this.optionGroup = this.defaultOptionGroup();
          return;
        }

        const { data } = await detailOptions(optionGroupId);
        this.optionGroup = data.row;

        if (this.optionGroup.items.length === 0) this.appendOptionItem();
      } catch (error) {
        console.log(error.response);
      } finally {
        bus.$emit('end:spinner');
      }
    },
    async registerOption() {
      bus.$emit('start:spinner');

      try {
        const validate = this.$refs.form.validate();
        if (!validate) return;

        const optionGroupId = this.$route.params.optionGroupId;
        const { data } = await (optionGroupId
          ? updateOptionGroup(optionGroupId, this.optionGroup)
          : createOptionGroup(this.optionGroup));
        if (data.result === 'success') {
          this.systemAlertHandle({ message: '매체가 등록 되었습니다.' });
          if (this.$route.name === 'mediaOptionRegister') {
            this.$router.replace({
              name: 'mediaOptionModify',
              params: { optionGroupId: data.value },
            });
          }
        }
      } catch (error) {
        let message;
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'DuplicatedEntry') {
          message = '이미 사용중인 매체명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          message = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }

        if (message) this.systemAlertHandle({ message });
      } finally {
        bus.$emit('end:spinner');
      }
    },
    async removeOptionItem(optionItemId) {
      bus.$emit('start:spinner');

      try {
        const { data } = await deleteOptionItem(
          this.$route.params.optionGroupId,
          optionItemId,
        );
        if (data.result === 'success') {
          this.systemAlertHandle({ message: '삭제되었습니다.', reload: true });
        }
      } catch (err) {
        console.log(err.response);
        const { data } = err.response;
        if (data.result === 'CannotBeEdited') {
          this.systemAlertHandle({
            message: '해당 옵션은 삭제할 수 없습니다.',
          });
        }
      } finally {
        bus.$emit('end:spinner');
      }
    },
    openRemoveConfirmPopup(optionItem, i) {
      if (!optionItem.id) {
        this.optionGroup.items.splice(i, 1);

        if (this.optionGroup.items.length === 0) this.appendOptionItem();
      } else {
        this.systemAlertHandle({
          message: '정말로 삭제하시겠습니까?',
          continue: async () => await this.removeOptionItem(optionItem.id),
          abort: () => {},
        });
      }
    },
    systemAlertHandle(data) {
      const defaultSystemAlert = {
        message: null,
        continue: null,
        abort: null,
        reload: false,
      };

      this.systemAlert.show = true;
      this.systemAlert.message = data.message;
      this.systemAlert.continue = async () => {
        this.systemAlert = defaultSystemAlert;

        if (data.continue) await data.continue();
        if (data.reload) await this.getOption(this.$route.params.optionGroupId);
      };
      if (data.abort) {
        this.systemAlert.abort = async () => {
          this.systemAlert = defaultSystemAlert;
          await data.abort();
        };
      }
    },
  },
  async created() {
    bus.$emit('start:spinner');

    await this.getOption(this.$route.params.optionGroupId);
  },
};
</script>
